import { render, staticRenderFns } from "./FormatColumn.vue?vue&type=template&id=ed1757d2&"
import script from "./FormatColumn.vue?vue&type=script&lang=js&"
export * from "./FormatColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports